import { achievementBadgesApi } from "@/apis/apis";
import { columns } from "./Columns";
import BaseTable from "./BaseTable";
import AchievementModal from "@/Modals/AchievementModal/Modal";

export default function AchievementBadgesPage() {
  return (
    <BaseTable
      label="Achievement Badges"
      apiURL={achievementBadgesApi}
      columns={columns()}
      ModalComponent={AchievementModal}
      enableAdd={false}
      enableExport={false}
      enableStatus={false}
    />
  );
}
